<template>
    <div class="oBox">
        <form class="form-horizontal">
            <div class="form-group">
                <label  class="col-sm-2 control-label">延期原因 <i>*</i></label>
                <div class="col-sm-8">
                    <label class="radio-lable">
                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="1" v-model="delay_type">入伍
                    </label>
                    <label  class="radio-lable">
                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="2" v-model="delay_type">疾病
                    </label>
                    <label  class="radio-lable">
                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="3" v-model="delay_type">其他
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label  class="col-sm-2 control-label">咨询老师 </label>
                <div class="col-sm-9">
                    <input type="text" class="form-control"  placeholder="资讯老师" value="黄老师" disabled>
                </div>
            </div>
            <div class="form-group">
                <label  class="col-sm-2 control-label">请假热线 </label>
                <div class="col-sm-9">
                    <input type="text" class="form-control"  placeholder="请假热线" value="0566-2092431" disabled>
                </div>
            </div>
            <div class="form-group">
                <label  class="col-sm-2 control-label">上传图片 <i>*</i></label>
                <div class="col-sm-8">
                    <!--上传图片 -->
                    <div class="tx-box">
                        <input type="file" id="file" name="file" accept="image/jpeg" @change="uploading">
                        <div class="tx-img">
                            <img  :src="src" alt="">
                        </div>
                        <button type="button" class="btn btn-default">上传照片</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="btn-box">
            <button type="button" class="btn btn-success btn-lg" data-toggle="modal" data-target="#myModal" v-if="check_state == 0">申请</button>
            <button type="button" class="btn btn-primary btn-lg"  v-if="check_state == 1" disabled>申请中</button>
            <button type="button" class="btn btn-info btn-lg"  v-if="check_state == 2" disabled>已通过</button>
            <button type="button" class="btn btn-danger btn-lg"   v-if="check_state == 3" disabled>已拒绝</button>
        </div>
        <!-- 提示框   -->
        <tip :tip="tip" v-show="tipShow"></tip>
         <page-load v-if="flags"></page-load>
        <!-- 模态框 -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	        <div class="modal-dialog">
		        <div class="modal-content">
			        <div class="modal-header">
				        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        &times;
				        </button>
				        <h4 class="modal-title" id="myModalLabel">
                        提示框
				        </h4>
			        </div>
                    <h4 class="modal-body">
				        确定提交吗
			        </h4>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">关闭
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal"  @click="_submit">
                            提交更改
                        </button>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
import { delayInfo, uploaddelayImg, delayInSchool } from "@/api/login.js";
import pageLoad from "../pageload/pageload";
import { apiUrl } from "@/api/config";
let Base64 = require("js-base64").Base64;
export default {
  components: { pageLoad },
  data() {
    return {
      tipShow: false, //tip提示
      tip: "", //tip提示信息
      delay_type: 0, //延迟报到类型
      check_state: 0, //审核状态
      src: "", //图片地址信息
      resource_id: [], //资源id
      url: apiUrl,
      flags: true
    };
  },
  created() {
    this._delayInfo();
  },
  methods: {
    //推迟入学申请
    _delayInSchool() {
      let module = {
        sch_id: JSON.parse(sessionStorage.getItem("stuInfo")).sch_id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        resource_id: this.resource_id,
        delay_type: this.delay_type
      };
      this.flags = true;
      delayInSchool(module).then(res => {
        this.flags = false;
        if (res.status) {
          this.tipCtr(res.msg);
        } else {
          this.tipCtr(res.msg);
        }
      });
    },
    //上传图片
    _uploaddelayImg(str) {
      let module = {
        sch_id: JSON.parse(sessionStorage.getItem("stuInfo")).sch_id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        file: str,
        ident: 1
      };
      uploaddelayImg(module).then(res => {
        this.tipCtr(res.msg);
        this.resource_id.push(res.data.resource_id);
      });
    },
    //图片预览
    uploading(e) {
      let _this = this;
      var files = e.target.files[0];
      if (!e || !window.FileReader) return;
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onloadend = function() {
        _this.src = this.result;
        _this._uploaddelayImg(_this.src);
      };
    },
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    },
    //提交
    _submit() {
      if (this.delay_type == 0) {
        this.tipCtr("请选择延期类型");
        return;
      } else if (this.resource_id == "") {
        this.tipCtr("请添加上传图片");
        return;
      }
      this._delayInSchool();
    },
    //获取延迟报到信息
    _delayInfo() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        sch_id: JSON.parse(sessionStorage.getItem("stuInfo")).sch_id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      delayInfo(module).then(res => {
        if (res.apply && res.data && res.status) {
          this.flags = false;
          this.delay_type = res.apply.delay_type;
          this.check_state = res.apply.check_state;
          var resourceId = res.apply.resource_id;
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].id == resourceId) {
              this.src =
                this.url + res.data[i].save_path + res.data[i].save_name;
            }
          }
        } else {
          this.flags = false;
          this.check_state = 0;
          this.delay_type = 0;
        }
      });
    }
  }
};
</script>
<style scoped>
.oBox {
  width: 70%;
  padding: 30px 0;
  margin: 0 auto;
}
.form-horizontal i {
  color: red;
  font-size: 16px;
  display: inline-block;
  margin-right: -10px;
}
input[type="radio"] {
  /*radiobox   原始 样式修改   */
  width: 20px;
  height: 20px;
  margin: -2px 5px 0 0 !important;
  vertical-align: middle;
  cursor: pointer;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  outline: none;
  border-radius: 100%;
}
input[type="radio"]:checked {
  /*checkbox   选中 样式修改   */
  background: #ff9000;
  border: none;
}
.radio-lable {
  padding-top: 9px;
  margin-right: 40px;
  cursor: pointer;
}
/***input 间距***/
form > div:last-child {
  margin-bottom: 0 !important;
}
.form-horizontal .form-group {
  margin: 0 0 20px;
}
/***input lable文字***/
.form-horizontal .control-label {
  padding-top: 8px;
  color: #333;
  font-size: 14px;
}
/***input***/
.form-control {
  height: 40px;
}
.btn-box {
  text-align: center;
}
.btn-box button {
  margin-top: 50px;
  min-width: 40%;
}
/*图片*/
.tx-box {
  width: 100%;
  position: relative;
}
.tx-box input {
  position: absolute;
  width: 82px;
  height: 32px;
  left: 20px;
  top: 240px;
  opacity: 0;
  cursor: pointer;
}
.tx-box button {
  margin: 20px;
}
.tx-img {
  width: 220px;
  height: 220px;
  overflow: hidden;
  padding: 5px;
  border: 1px #ddd solid;
  cursor: pointer;
}
.tx-img img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/delayReportInfo.vue